import { AlphaCard, FieldErrors, Visual } from 'components/Alpha/cards/cardTypes';

export interface IAlphaPodContext {
  psaId: number;
  psa: string;
  ticketId?: string;
  screen: string;
  contactId?: string;
}

export interface IAlphaResolvedContext {
  kind: 'ticket' | 'contact' | 'project_ticket';
  crmSourceId: number;
  psaType: string;
  ticketNumber?: string;
  summary?: string;
  companyName?: string;
  contactName?: string;
  asOf: string;
}

export interface ICreateAlphaSessionRequest {
  title?: string;
  podContext: IAlphaPodContext;
}

export type IAlphaResolvedContextResult = IAlphaResolvedContext | { kind: 'none' } | null;

export interface ICreateAlphaSessionResult {
  id: number;
  title?: string;
  createdAt: string;
  resolvedContext?: IAlphaResolvedContextResult;
}

export interface IAlphaSessionSummary {
  id: number;
  title?: string;
  createdAt: string;
  podKind?: 'ticket' | 'project_ticket' | 'contact' | null;
  crmSourceId?: number | null;
  externalId?: string | null;
  psaDisplayName?: string | null;
}

export interface IAlphaStoredMessage {
  id: number;
  sessionId: number;
  role: 'user' | 'assistant' | 'tool';
  contentJson: string;
  createdAt: string;
  synthetic?: boolean;
  channel?: 'chat' | 'voice';
  voice?: { hidden?: boolean } | null;
}

export type AlphaCardKind = AlphaCard['kind'];

export interface IAlphaPendingConfirmationDto {
  toolName: string;
  previewJson: string;
  token: string;
  expiresAt: string;
  kind?: AlphaCardKind;
  card?: AlphaCard | null;
  reviewUrl?: string | null;
  title?: string;
}

export interface IAlphaCardOptionDto {
  value: string | number;
  label: string;
  detail?: string | null;
}

export const ALPHA_TIMEOUT_MESSAGE = 'Alpha is taking longer than usual.';

export const ALPHA_UNREACHABLE_MESSAGE = 'Alpha could not finish that request. Try again.';
export const ALPHA_CONFIRMATION_EXPIRED_MESSAGE = 'This confirmation has expired. Ask Alpha again.';
export const ALPHA_STALLED_MESSAGE =
  'Alpha is taking longer than expected and did not respond. Please try again.';

export const ALPHA_NO_RESPONSE_MESSAGE = "Alpha didn't respond. Try again.";

export type AlphaEvent =
  | { type: 'text_delta'; text: string }
  | {
      type: 'tool_call';
      toolName: string;
      input: unknown;
      toolUseId: string;
      label?: string;
    }
  | {
      type: 'tool_result';
      toolName: string;
      toolUseId: string;
      ok: boolean;
      result: unknown;
      outcome?: string;
      label?: string;
    }
  | {
      type: 'confirmation_required';
      toolName: string;
      preview: unknown;
      token: string;
      reviewUrl?: string;
      title?: string;
    }
  | {
      type: 'card_required';
      kind: AlphaCardKind;
      toolName: string;
      token: string;
      card: AlphaCard;
      title?: string;
    }
  | { type: 'card_error'; token: string; message: string; fieldErrors?: FieldErrors }
  | { type: 'visual'; visual: Visual }
  | { type: 'done'; stopReason: string; inputTokens: number; outputTokens: number }
  | { type: 'error'; message: string; origin?: 'client' }
  | { type: 'rate_limited'; retryAfterSeconds: number; message?: string }
  | { type: 'turn_in_progress' }
  | { type: 'timeout' };
